export default {
  invitation: {
    text: {
      sk:
        'Máte záujem o bezplatnú konzultáciu? Príďte sa porozprávať o svojich cieľoch do našej kancelárie v centre Bratislavy. Čaká vás čerstvo upražená arabica!',
      en:
        'Interested in a free consultation? Get in touch or visit us in our office in the centre of Bratislava, Slovakia. Our freshly brewed arabica is waiting for you!',
    },
    button: {
      link: {
        sk: '/sk/kontakt',
        en: '/contact',
      },
      text: {
        sk: 'Kontakt',
        en: 'Contact',
      },
    },
  },
  newsletter: {
    form: {
      input: {
        placeholder: {
          sk: 'Váš e-mail',
          en: 'Your e-mail address',
        },
      },
      button: {
        text: {
          sk: 'Odoberať',
          en: 'Subscribe',
        },
      },
    },
  },
  foot: {
    phone: {
      title: {
        sk: 'Telefón',
        en: 'Phone',
      },
      formatted: {
        sk: '+421 948 225 552',
        en: '+421 948 225 552',
      },
    },
    email: {
      title: {
        sk: 'E-mail',
        en: 'E-mail',
      },
      value: {
        sk: 'hello@lbstudio.sk',
        en: 'hello@lbstudio.sk',
      },
    },
    socials: {
      sk: [
        {
          title: 'Facebook',
          link: 'https://www.facebook.com/lbstudio/',
          icon: 'social-facebook',
        },
        {
          title: 'Instagram',
          link: 'https://www.instagram.com/lightingbeetle/',
          icon: 'social-instagram',
        },
        {
          title: 'Twitter',
          link: 'https://twitter.com/lightingbeetle',
          icon: 'social-twitter',
        },
        {
          title: 'Medium',
          link: 'https://medium.com/@lightingbeetle/',
          icon: 'social-medium',
        },
      ],
    },
  },
  gdpr: {
    link: {
      sk: '/gdpr.pdf',
      en: '/gdpr.pdf',
    },
    text: {
      sk: 'Ochrana osobných údajov',
      en: 'Personal data protection',
    },
  },
};



// WEBPACK FOOTER //
// ./src/data/components/footer.js